import {Font, StyleSheet, Text, View} from "@react-pdf/renderer";
import RobotoRegular from "../../../assets/fonts/Roboto-Regular.ttf";
import RobotoItalic from "../../../assets/fonts/Roboto-Italic.ttf";
import RobotoBoldItalic from "../../../assets/fonts/Roboto-BoldItalic.ttf";
import RobotoBold from "../../../assets/fonts/Roboto-Bold.ttf";

// This component handles unordered lists in the pdf generator
export default function TableListContent({data}) {

    return (
        <View>
            {data.split("\n").map((row, i) => {
                if (row.substring(0, 5).includes('-') && !row.substring(0, 5).includes('Y-')) {
                    return <View key={i} style={{flexDirection: "column"}}>
                        <View style={styles.unorderdList}>
                            <Text style={styles.unorderdListBullet}>•</Text>
                            <Text style={styles.unorderdListText}>{row.substring(row.indexOf('-') + 1, row.length).trimStart()}</Text>
                        </View>
                    </View>
                } else if (row.includes("{") && row.includes("}")) {
                    return <Text key={i}  style={styles.textBoldUnderline}>{row.substring(1, row.length - 1)}</Text>
                } else return <Text key={i} >{row || "\n"}</Text>
            })}
        </View>
    )
}


Font.register({
    family: 'Roboto', fonts: [
        {src: RobotoRegular}, // font-style: normal, font-weight: normal
        {src: RobotoItalic, fontStyle: 'italic'},
        {src: RobotoBoldItalic, fontStyle: 'italic-bold'},
        {src: RobotoBold, fontStyle: 'bold'},
    ]
});

const styles = StyleSheet.create({
    unorderdList: {flexDirection: "row", marginBottom: 4},
    unorderdListBullet: {marginHorizontal: 8},
    unorderdListText: {width: "95%"},
    textBoldUnderline: {
        fontFamily: "Roboto",
        fontStyle: "bold",
        textDecoration: "underline"
    },
})